var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"editor"},[_c('div',{staticClass:"width-100"},[_c('StepDetailsHeader',_vm._g({attrs:{"icon":"notification-bell","serviceId":_vm.editNode.service,"showDropdownMenu":false}},_vm.$listeners))],1),_c('NotificationEditorBody',{attrs:{"hasEditPermissions":_vm.hasEditPermissions}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }